import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/adminManage',
  redirect: 'noredirect',
  name: 'adminManage',
  component: Layout,
  meta: {
    title: '课题申报管理',
    icon: 'admin'
  },
  children: [
    {
      path: 'adminManage',
      component: () => import('@/views/adminManage/adminmange/index.vue'),
      name: 'adminManage',
      meta: {
        title: '课题申报管理',
        icon: 'adminmanage',
        requireAuth: true
      }
    },
    {
      path: 'expertmanage',
      component: () => import('@/views/adminManage/expertmanage/index.vue'),
      name: 'expertmanage',
      meta: {
        title: '课题申报',
        icon: 'expert',
        requireAuth: true
      }
    },
  ]
}

export default equipRouter
